import React, { Component } from "react";
import { observer } from "mobx-react";

import ApplicationListRow from "./ApplicationListRow";

export default observer(
  class index extends Component {
    render() {
      const { applicationsStore, filter } = this.props;

      const filteredRows = applicationsStore.filter(
        r =>
          filter === "undefined" ||
          !filter ||
          (r.Number &&
            r.Number.toString().indexOf(filter.toLowerCase()) !== -1) ||
          (r.Name && r.Name.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
      );

      let rows = null;
      if (filteredRows) {
        rows = filteredRows.map(application => {
          return (
            <ApplicationListRow
              key={application.Id}
              application={application}
            />
          );
        });
      }

      return (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Number</th>
              <th>Name</th>
              <th>Last updated</th>
              <th className="col-sm-1" />
              <th className="col-sm-1" />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/ApplicationsList/index.js